var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_661_1430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 3.3335H3.33317C2.40817 3.3335 1.67484 4.07516 1.67484 5.00016L1.6665 15.0002C1.6665 15.9252 2.40817 16.6668 3.33317 16.6668H16.6665C17.5915 16.6668 18.3332 15.9252 18.3332 15.0002V5.00016C18.3332 4.07516 17.5915 3.3335 16.6665 3.3335ZM15.8332 15.0002H4.1665C3.70817 15.0002 3.33317 14.6252 3.33317 14.1668V10.0002H16.6665V14.1668C16.6665 14.6252 16.2915 15.0002 15.8332 15.0002ZM16.6665 6.66683H3.33317V5.00016H16.6665V6.66683Z",
    fill: "#00A0F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_661_1430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreditCard);
export default __webpack_public_path__ + "static/media/IconCreditCard.7ac92d30b9ce9a3845090307c6163b8b.svg";
export { ForwardRef as ReactComponent };